import styled from 'styled-components';
import UserInitials from '@/trio-ui/UserInitials';

export const Bar = styled.div<{ percentage: number; color?: string }>`
  width: 32px;
  height: ${(props) => `${props.percentage}%`};
  position: relative;
  background: ${(props) => props.color ?? props.theme.colors['primary-60']};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Container = styled.div`
  height: 100%;
  text-align: center;
  width: 70px;
  justify-content: end;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 570px;
`;

export const CustomUserInitials = styled(UserInitials)`
  width: 24px;
  height: 24px;
  margin: 0;
  margin-bottom: 4px;
`;

export const Name = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 8px;
`;

export const ChartArea = styled.div<{ isCentered?: boolean }>`
  display: flex;
  justify-content: ${(props) => (!props.isCentered ? 'space-around' : 'space-between')};
`;

export const Number = styled.p`
  margin-bottom: 8px;
  font-size: 18px;
  line-height: 21px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-100']};
  position: relative;
  top: -22px;
`;

export const BarArea = styled.div`
  height: calc(100% - 30px);
  margin-top: 26px;
  display: flex;
  align-items: center;
  justify-content: end;
  flex-direction: column;
`;
